import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchableInputList',
  standalone: false,
})
export class SearchableInputListPipe implements PipeTransform {

  transform(inputList: string[], query: string): string[] {
    if (!query) return inputList;
    return inputList.filter((item) =>
      item.toLowerCase().includes(query.trim().toLowerCase()));
  }

}
